import { OrderAsset } from '../../domain/entities/order-asset.entity';

export interface OrderAssetApiResponse {
  id: string;
  propertyRegistryNumber: string | null;
  propertyRegistry: string | null;
  cadastralReference: string | null;
  idufir: string | null;
  createdAt: string | null;
}

export interface OrderAssetGetAllApiResponse {
  items: OrderAssetApiResponse[] | null;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
}

export class OrderAssetMapper {
  static toDomain(raw: OrderAssetApiResponse): OrderAsset {
    return {
      id: raw.id,
      propertyRegistryNumber: raw.propertyRegistryNumber,
      propertyRegistry: raw.propertyRegistry,
      cadastralReferences: raw.cadastralReference ? [raw.cadastralReference] : null,
      idufir: raw.idufir,
      createdAt: raw.createdAt ? new Date(raw.createdAt) : null,
    };
  }

  static toDomainList(rawList: OrderAssetApiResponse[]): OrderAsset[] {
    return rawList.map((raw) => this.toDomain(raw));
  }
}
